import React from 'react';
import { CompanyDetailInfo } from '../types/company';

interface AboutCardProps {
  companyDetailInfo: CompanyDetailInfo;
}

const AboutCard: React.FC<AboutCardProps> = ({ companyDetailInfo }) => {
  return (
    <div className="about px-4 sm:px-12 md:px-12">
      <div className="border border-white rounded">
        <div className="p-2 sm:p-4 md:p-4 text-sm sm:text-lg md:text-xl lg:text-2xl border-b border-white font-semibold">About</div>
        <div className="p-2 sm:p-4 md:p-4 text-sm sm:text-lg md:text-lg">
          <div className="description border-b border-white pb-4">
            <div className="text-sm sm:text-md md:text-lg lg:text-xl font-semibold mb-2">Description</div>
            <div className="text-[10px] sm:text-sm md:text-base lg:text-lg text-gray-300">{companyDetailInfo.description}</div>
          </div>

          <div className="basic-information grid grid-cols-3 gap-6 my-2 sm:my-3 md:my-4 text-[11px] sm:text-base md:text-lg">
            <div>
              <div className="text-[10px] sm:text-base md:text-md">Headquarters</div>
              <div className="text-white">{companyDetailInfo.location}</div>
            </div>
            <div>
              <div className="text-[10px] sm:text-base md:text-md">Founded</div>
              <div className="text-white">{companyDetailInfo.foundedYear}</div>
            </div>
            <div>
              <div className="text-[10px] sm:text-base md:text-md">Sector</div>
              <div className="text-white">{companyDetailInfo.category}</div>
            </div>
          </div>

          <div>
            <div className="text-[10px] sm:text-base md:text-md">Website</div>
            <a
              href={companyDetailInfo.linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300"
            >
              {companyDetailInfo.domain}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutCard;
